import './ProfileHeader.css';
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LanguageIcon from '@mui/icons-material/Language';
import logo from '../../../assets/newro-green-logo.svg'

const ProfileHeader = ({ person, onSubscribe }) => {
    const renderStars = (rating) => {
        const stars = [];
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 >= 0.5;

        for (let i = 0; i < 5; i++) {
            if (i < fullStars) {
                stars.push(<span key={i} className="star star--filled">★</span>);
            } else if (i === fullStars && hasHalfStar) {
                stars.push(<span key={i} className="star star--half">★</span>);
            } else {
                stars.push(<span key={i} className="star star--empty">★</span>);
            }
        }
        return stars;
    };

    // Calculate mock stats based on existing data
    const stats = {
        reputation: person.rating,
        totalReviews: person.reviewCount,
        clients: Math.floor(person.reviewCount * 1.8),
        successRate: (85 + Math.random() * 10).toFixed(1)
    };

    return (
        <div className="profile-header">
            {/* Cover Photo Section */}
            <div
                className="profile-header__cover"
                style={{ backgroundImage: `url(${person.coverPhoto})` }}
            >
            </div>

            {/* Profile Content Section */}
            <div className="profile-header__content">
                {/* Avatar - Circular, overlapping cover */}
                <div className="profile-header__avatar">
                    <img
                        src={person.primaryPhoto}
                        alt={person.name}
                        loading="lazy"
                    />
                </div>

                {/* Main Info */}
                <div className="profile-header__info">
                    <div className="profile-header__name-row">
                        <h1 className="profile-header__name">{person.name}</h1>
                        <span className="profile-header__verified-badge">
                            ✓ Verified
                        </span>
                    </div>

                    {/* Social Icons */}
                    <div className="profile-header__social-icons">
                        {person?.socials?.web &&
                            <a href={person.socials.web} target="_blank" rel="noopener noreferrer" className="profile-header__social-icon">
                                <LanguageIcon sx={{ fontSize: 16 }} />
                            </a>}
                        {person?.socials?.instagram &&
                            <a href={person.socials.instagram} target="_blank" rel="noopener noreferrer" className="profile-header__social-icon">
                                <InstagramIcon sx={{ fontSize: 16 }} />
                            </a>}
                        {person?.socials?.facebook &&
                            <a href={person.socials.facebook} target="_blank" rel="noopener noreferrer" className="profile-header__social-icon">
                                <FacebookIcon sx={{ fontSize: 16 }} />
                            </a>}
                    </div>

                    {/* Roles as subtitle */}
                    <p className="profile-header__roles-text">
                        {person.roles.join(', ')}
                    </p>

                    {/* Location Badge - Supporting metadata under roles */}
                    <div className="profile-header__location">
                        <svg className="profile-header__location-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                            <circle cx="12" cy="10" r="3" />
                        </svg>
                        <span>{person.profile.location}</span>
                    </div>
                </div>
            </div>
                <div class="background-logo">
                    <img src={logo} />
                </div>
        </div>
    );
};

export default ProfileHeader;
